import $ from "jquery"; // the page's jQuery, see `externals` in webpack.mix.js

$(document).ready(function () {
    setTimeout(function () {
        window.createMap();
    }, 1000);
});

window.createMap = () => {

    var mapboxCss = 'mpboxCSS';  // you could encode the css path itself to generate id..
    if (!document.getElementById(mapboxCss))
    {
        var head  = document.getElementsByTagName('head')[0];
        var link  = document.createElement('link');
        link.id   = mapboxCss;
        link.rel  = 'stylesheet';
        link.type = 'text/css';
        link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.3.1/mapbox-gl.css';
        link.media = 'all';
        head.appendChild(link);
    };

    const geojson = {
        'type': 'FeatureCollection',
        'features': properties
    };

    // initialise your mapbox here
    mapboxgl.accessToken = 'pk.eyJ1IjoiY2hpYXJhYmVubnkiLCJhIjoiY2p0dTg5bml4MDM1ZzRmcGxtdGMyanVseCJ9.Stf1KrbsHX1K5eIpFWj91Q';
    const map = new mapboxgl.Map({
        container: document.getElementById('mapParent'),
        style: 'mapbox://styles/chiarabenny/cky8jns1o1ysh14s06fj6hrxw',
    });

    map.addControl(new mapboxgl.NavigationControl(), 'bottom-left');
    map.scrollZoom.disable();
    map.dragRotate.disable();

    // add markers to map
    for (const feature of geojson.features) {
        // create a HTML element for each feature
        const el = document.createElement('div');
        el.className = 'marker';

        if (feature.properties.toggle_novita === 'true') {
            el.classList.add('marker-eraclea');
        }

        el.addEventListener('click', (prop) => {
            document.getElementById('struttura').classList.remove('d-none');
            document.getElementById('struttura-img').src = feature.properties.cover;
            document.getElementById('struttura-title').innerHTML = feature.properties.title;
            document.getElementById('struttura-location').innerHTML = feature.properties.location;
            document.getElementById('struttura-sub').innerHTML = feature.properties.subtitle;
            document.getElementById('struttura-desc').innerHTML = feature.properties.description;
            document.getElementById('url').setAttribute('href', feature.properties.url);

            const tagNovita = document.getElementById('toggle-novita');

            if (feature.properties.toggle_novita === 'true') {
                tagNovita.classList.remove('d-none');
            } else {
                tagNovita.classList.add('d-none');
            }
            // Clear the previous selection, then mark this one. `el` is this
            // marker, so nothing further is needed.
            //
            // What was here re-derived the same element from `prop.path[0]`,
            // and `Event.path` is a non-standard legacy alias for
            // composedPath() that neither current Chrome nor Safari provides.
            // It was also self-defeating: the branch above had just set the id,
            // so getElementById always matched, the else branch removed it
            // again, and the line that would have restored it threw first. The
            // net effect was that no marker ever carried #selected-marker, so
            // clicking one never highlighted it and the map opened with the
            // auto-clicked first marker unmarked.
            document.querySelectorAll('.marker').forEach(m => m.removeAttribute('id'));
            el.setAttribute('id', 'selected-marker');
        });

        // make a marker for each feature and add it to the map
        new mapboxgl.Marker(el)
            .setLngLat(feature.geometry.coordinates)
            .addTo(map);
    }

    map.on('load', () => {
        document.getElementsByClassName('marker')[0].click();
    });
}

